import {Field} from "formik";
import React from "react";

export default ({name, label, disabled, span, autoFocus = false}) => {
  const [isFocus, setFocus] = React.useState(false);
  return (
    <Field name={name}>
      {({field, meta: { touched, error, value }}) => {
        function toggleFocus(e) {
          if (isFocus) field.onBlur(e);
          setFocus(!isFocus);
        }
        return (
          <div className={`formGroup${(touched && error) ? ' error' : ''}${(span) ? ' span-'+span : ''}`}>
            <label className={`fieldLabel${(value||isFocus) ? ' touched' : ''}`}>{label}</label>
            <input className='formField' type="text" {...field} disabled={disabled} onFocus={toggleFocus} onBlur={toggleFocus} autoFocus={autoFocus}/>
            {touched && error && <div className="errorMessage">{error}</div>}
          </div>
        )
      }}
    </Field>
  )
}